import React from 'react'

import "./Contacts.scss";

function Contacts() {
  return (
    <div className="container honey-contacts">
      <h3 className="has-text-weight-bold is-size-3 honey-text-font-family-common honey-text-common">
        Contact Us
      </h3>
      <div className="level is-size-1 honey-text-common">
        <div className="level-item has-text-centered">
          <div>
            <a target="_blank" rel="noopener noreferrer" href="mailto:info@honeyshare.live"><i className="fa-solid fa-envelope"></i></a>
          </div>
        </div>
        <div className="level-item has-text-centered">
          <div>
            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/honeyshare"><i className="fa-brands fa-linkedin"></i></a>
          </div>
        </div>
        <div className="level-item has-text-centered">
          <div>
            <a target="_blank" rel="noopener noreferrer" href="https://github.com/HoneyShare/HoneyShareLib"><i className="fa-brands fa-github"></i></a>
          </div>
        </div>
        <div className="level-item has-text-centered">
          <div>
            <a target="_blank" rel="noopener noreferrer" href="https://pypi.org/project/honeyshare/"><i className="fa-brands fa-python"></i></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contacts;
